import mergeWith from 'lodash/mergeWith';

import { fontOverrides } from './fontOverrides';

export const overrideTheme = (defaultTheme = {}, overrides = {}) =>
  mergeWith(defaultTheme, Object.assign({}, fontOverrides, overrides));
